import React, { useEffect, useState } from "react";

export default function AadhaarOtpInput(props) {
  const [state, setState] = useState({
    value: "",
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
    disable: true,
  });

  useEffect(() => {
    props.sendData(`${state.otp1}${state.otp2}${state.otp3}${state.otp4}${state.otp5}${state.otp6}`);
  }, [state]);

  const handleChange = (value1, event) => {
    setState({ ...state, [value1]: event.target.value });
  };

  const validate = (event) => {
    if (
      event.key === "Backspace" ||
      event.key === "Delete" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      (event.keyCode >= 48 && event.keyCode <= 57) || // 0-9
      (event.keyCode >= 65 && event.keyCode <= 90) || // A-Z
      (event.keyCode >= 97 && event.keyCode <= 122) // a-z
    ) {
      return true;
    }
    event.preventDefault();
  };

  const inputfocus = (event) => {
    if (!validate(event)) {
      return;
    }
    if (event.key === "Delete" || event.key === "Backspace") {
      const next = event.target.tabIndex - 2;
      if (!event.target.value) {
        if (next > -1) {
          event.target.form.elements[next].focus();
          event.target.form.elements[next].select();
        }
      }
    } else {
      const next = event.target.tabIndex;
      if (event.target.value > -1 && next < 6) {
        event.target.form.elements[next].focus();
      }
    }
  };
  

  return (
    <form>
      <div className="container height-100 d-flex justify-content-center align-items-center">
        <input
          name="otp1"
          type="text"
          autoComplete="off"
          inputMode="numeric"
          className="form-control m-2 text-center form-control rounded otpInput"
          value={state.otp1}
          onChange={(e) => handleChange("otp1", e)}
          tabIndex="1"
          maxLength="1"
          onKeyDown={(e) => validate(e)}
          onKeyUp={(e) => inputfocus(e)}
          onPaste={(e) => e.preventDefault()}
        />
        <input
          name="otp2"
          type="text"
          autoComplete="off"
          inputMode="numeric"
          className="form-control m-2 text-center form-control rounded otpInput"
          value={state.otp2}
          onChange={(e) => handleChange("otp2", e)}
          tabIndex="2"
          maxLength="1"
          onKeyDown={(e) => validate(e)}
          onKeyUp={(e) => inputfocus(e)}
          onPaste={(e) => e.preventDefault()}
        />
        <input
          name="otp3"
          type="text"
          autoComplete="off"
          inputMode="numeric"
          className="form-control m-2 text-center form-control rounded otpInput"
          value={state.otp3}
          onChange={(e) => handleChange("otp3", e)}
          tabIndex="3"
          maxLength="1"
          onKeyDown={(e) => validate(e)}
          onKeyUp={(e) => inputfocus(e)}
          onPaste={(e) => e.preventDefault()}
        />
        <input
          name="otp4"
          type="text"
          autoComplete="off"
          inputMode="numeric"
          className="form-control m-2 text-center form-control rounded otpInput"
          value={state.otp4}
          onChange={(e) => handleChange("otp4", e)}
          tabIndex="4"
          maxLength="1"
          onKeyDown={(e) => validate(e)}
          onKeyUp={(e) => inputfocus(e)}
          onPaste={(e) => e.preventDefault()}
        />
        <input
          name="otp5"
          type="text"
          autoComplete="off"
          inputMode="numeric"
          className="form-control m-2 text-center form-control rounded otpInput"
          value={state.otp5}
          onChange={(e) => handleChange("otp5", e)}
          tabIndex="5"
          maxLength="1"
          onKeyDown={(e) => validate(e)}
          onKeyUp={(e) => inputfocus(e)}
          onPaste={(e) => e.preventDefault()}
        /><input
        name="otp6"
        type="text"
        autoComplete="off"
        inputMode="numeric"
        className="form-control m-2 text-center form-control rounded otpInput"
        value={state.otp6}
        onChange={(e) => handleChange("otp6", e)}
        tabIndex="6"
        maxLength="1"
        onKeyDown={(e) => validate(e)}
        onKeyUp={(e) => inputfocus(e)}
        onPaste={(e) => e.preventDefault()}
      />
      </div>
    </form>
  );
}
